import { render } from "./ListaSolicitacoesView.vue?vue&type=template&id=20ccc3e4&scoped=true"
import script from "./ListaSolicitacoesView.vue?vue&type=script&lang=js"
export * from "./ListaSolicitacoesView.vue?vue&type=script&lang=js"

import "./ListaSolicitacoesView.vue?vue&type=style&index=0&id=20ccc3e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ccc3e4"]])

export default __exports__